let graph = require('@microsoft/microsoft-graph-client');

function getAuthenticatedClient(accessToken) {
  const token = typeof accessToken === 'string' ? accessToken : accessToken?.accessToken;

  // Initialize Graph client
  return graph.Client.init({
    // Use the provided access token to authenticate
    // requests
    authProvider: (done) => {
      done(null, token);
    }
  });
}

export async function getUserDetails(accessToken) {
  const client = getAuthenticatedClient(accessToken);

  return await client.api('/me').get();
}